import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LiveFeedAnimationWrapper, LiveFeedAnimationContentWrapper } from './LiveFeedAnimation.style';

const LiveFeedAnimation = ({
    children,
    duration = 0.3,
    delay = 1
}) => {
    const contentWrapper = useRef(null);
    const [animatingTo, setAnimatingTo] = useState(0);
    const [animationComplete, setAnimationComplete] = useState(false);

    // Trigger the element to animate after inspecting the proper height needed.
    const animate = () => {
        const height = contentWrapper?.current?.clientHeight;
        if (height) {
            setAnimatingTo(height);
        }
    };

    // If we're animating, set a timeout to "complete" it.
    // That will revert the height to auto and not the fixed height.
    useEffect(() => {
        if (animatingTo) {
            setTimeout(() => {
                setAnimationComplete(true);
            }, duration * 1000);
        }
    }, [animatingTo]);

    // Set the element to animate after a passed delay
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            animate();
        }, delay * 1000);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <LiveFeedAnimationWrapper
            style={{
                height: animationComplete ? 'auto' : `${animatingTo}px`
            }}
        >
            <LiveFeedAnimationContentWrapper
                ref={ contentWrapper }
            >
                { children }
            </LiveFeedAnimationContentWrapper>
        </LiveFeedAnimationWrapper>
    );
};

LiveFeedAnimation.propTypes = {
    duration: PropTypes.number,
    delay: PropTypes.number,
    children: PropTypes.node
};

export default LiveFeedAnimation;
